import {
  CicloPassivoFieldsDto,
  ContractOrderOutputDto,
  ContractOrderOutputListDto,
  ContractOrderSFSearchInputDto,
  FatturaEmessaDto,
  FatturaEmessaSearchDto,
  ProjectCicloPassivoOutputDto,
} from '@api/client';
import { createReducer } from '@reduxjs/toolkit';
import {
  getActiveCycleFattureEmesse,
  getActiveCycleOptions,
  getAssociableProjects,
  resetAssociableInvoices,
  resetOrderAttivo,
  saveFiltersActiveAssociableInvoicesUsed,
  saveFiltersOrdersSfUsed,
  searchActiveOrders,
  searchActiveOrdersSf,
  searchActiveOrdersSfDetail,
} from './actions';

interface InitialState {
  activeCycleOptions: CicloPassivoFieldsDto | undefined;
  activeOrdersSf: ContractOrderOutputListDto | undefined;
  activeOrderSfDetail: ContractOrderOutputListDto | undefined;
  activeCycleOrdersAttivi: ContractOrderOutputDto[]; //  searchOrdersAttivi
  activeCycleOrdersAttiviForBills: ContractOrderOutputDto[]; // searchOrdersAttivi
  activeCycleFattureEmesse: FatturaEmessaDto[];
  associableProjects: ProjectCicloPassivoOutputDto[];
  associableInvoices: FatturaEmessaDto[];
  filtersOrdersSfUsed: ContractOrderSFSearchInputDto | undefined;
  filtersActiveAssociableInvoicesUsed: FatturaEmessaSearchDto | undefined;
  associableInvoicesPaging: {
    page: number | undefined;
    size: number | undefined;
    totalElements: number | undefined;
    totalPages: number | undefined;
  };
}

const initialState: InitialState = {
  activeCycleOptions: undefined,
  activeOrdersSf: undefined,
  activeOrderSfDetail: undefined,
  activeCycleOrdersAttivi: [],
  activeCycleOrdersAttiviForBills: [],
  activeCycleFattureEmesse: [],
  associableProjects: [],
  associableInvoices: [],
  filtersOrdersSfUsed: undefined,
  filtersActiveAssociableInvoicesUsed: undefined,
  associableInvoicesPaging: {
    page: undefined,
    size: undefined,
    totalElements: undefined,
    totalPages: undefined,
  },
};

export const activeCycleReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(getActiveCycleOptions.fulfilled, (state, action) => {
      state.activeCycleOptions = action.payload;
    })
    .addCase(searchActiveOrdersSf.fulfilled, (state, action) => {
      state.activeOrdersSf = action.payload;
    })
    .addCase(searchActiveOrdersSfDetail.fulfilled, (state, action) => {
      state.activeOrderSfDetail = action.payload;
    })
    .addCase(searchActiveOrders.fulfilled, (state, action) => {
      if (action.meta.arg.contractOrderSearchDto.isLight) {
        state.activeCycleOrdersAttiviForBills = action.payload?.contractOrderOutputDtoList || [];
      } else {
        state.activeCycleOrdersAttivi = action.payload?.contractOrderOutputDtoList || [];
      }
    })
    .addCase(getActiveCycleFattureEmesse.fulfilled, (state, action) => {
      const type = action.meta.arg.type;
      switch (type) {
        case 'associated':
          state.activeCycleFattureEmesse = action.payload?.content || [];
          break;
        case 'associable':
          state.associableInvoices = action.payload?.content || [];
          state.associableInvoicesPaging = {
            page: action.payload?.page,
            size: action.payload?.size,
            totalElements: action.payload?.totalElements,
            totalPages: action.payload?.totalPages,
          };
          break;
      }
    })
    .addCase(getAssociableProjects.fulfilled, (state, action) => {
      state.associableProjects = action.payload?.projectCicloPassivoOutputDtoList || [];
    })
    .addCase(saveFiltersOrdersSfUsed, (state, action) => {
      state.filtersOrdersSfUsed = action.payload;
    })
    .addCase(saveFiltersActiveAssociableInvoicesUsed, (state, action) => {
      state.filtersActiveAssociableInvoicesUsed = action.payload;
    })
    .addCase(resetAssociableInvoices, (state) => {
      state.filtersActiveAssociableInvoicesUsed = undefined;
      state.associableInvoices = [];
      state.associableInvoicesPaging = {
        page: undefined,
        size: undefined,
        totalElements: undefined,
        totalPages: undefined,
      };
    })
    .addCase(resetOrderAttivo, (state) => {
      state.activeCycleOrdersAttivi = [];
    });
});
